import React from "react";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import "./Contact.css";
import { ReactComponent as LocationIcon } from "../../assets/icons/location.svg";
import { ReactComponent as PhoneIcon } from "../../assets/icons/phone.svg";
import { ReactComponent as MobileIcon } from "../../assets/icons/mobile.svg";
import { ReactComponent as FaxIcon } from "../../assets/icons/fax.svg";
import { ReactComponent as EmailIcon } from "../../assets/icons/email.svg";
// replaced Facebook with Instagram icon - add assets/icons/insta.svg to the project
import instaIcon from "../../assets/icons/insta.svg";
import liIcon from "../../assets/icons/linkedin.svg";
import mailIcon from "../../assets/icons/gmail.svg";
import ChatWithUs from "../../components/ChatWithUs/ChatWithUs";

const Contact = () => {
  return (
    <>
      <Navbar />

      <div className="contact-page">
        <h2 className="contact-heading">Get in Touch</h2>
        <div className="contact-icons">
          <a
            href="https://www.instagram.com/newbell_yiwu"
            target="_blank"
            rel="noreferrer"
            className="circle-icon"
          >
            <img src={instaIcon} alt="Instagram" />
          </a>
          <a
            href="https://www.linkedin.com/in/newbell-international-exports-70b3a4263/"
            target="_blank"
            rel="noreferrer"
            className="circle-icon"
          >
            <img src={liIcon} alt="LinkedIn" />
          </a>
          <a
            href="mailto:exports@newbell.net"
            className="circle-icon"
            title="Email"
          >
            <img src={mailIcon} alt="Gmail" />
          </a>
        </div>

        <div className="branch-container">
          {/* Thailand Branch */}
          <div className="branch">
            <h3>Thailand Branch</h3>
            <p>
              <LocationIcon /> <strong>Address</strong>
              <br />
              Newbell International Trading Co., Ltd
              <br />
              318/31 Soi Sukhumvit 22, Sukhumvit Road,
              <br />
              Kwaeng Klongtoey, Khet Klongtoey,
              <br />
              Bangkok 10110, Thailand
            </p>
            <p>
              <PhoneIcon /> <strong>Phone</strong>
              <br /> +66-2-204-1645
            </p>
            <p>
              <MobileIcon /> <strong>Mobile</strong>
              <br /> +66 818403643
              <br /> +66 988540410
            </p>
            <p>
              <FaxIcon /> <strong>Fax</strong>
              <br /> +66-2-261-0874
            </p>
            <p>
              <EmailIcon /> <strong>Email</strong>
              <br /> kunal@newbell.net
              <br /> varun@newbell.net
            </p>
            <iframe
              title="Thailand Map"
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d413.9978771742437!2d100.56381362193319!3d13.721774149159343!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e29f055f28c6fb%3A0xde6b6ee5246ad4a7!2s318%20Sukhumvit%20Alley%2022%2C%20Khlong%20Tan%2C%20Khet%20Khlong%20Toei%2C%20Krung%20Thep%20Maha%20Nakhon%2010110%2C%20Thailand!5e1!3m2!1sen!2sus!4v1763097614909!5m2!1sen!2sus"
              width="100%"
              height="200"
              style={{ border: 0, marginTop: "15px" }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>

          {/* China Branch */}
          <div className="branch">
            <h3>China Branch</h3>
            <p>
              <LocationIcon /> <strong>Address</strong>
              <br />
              Qu Yuan Xiao Qu, Building No. 5, Gate-2,
              <br />
              Room no. 101, Yiwu City,
              <br />
              Zhejiang Province, China
            </p>
            <p>
              <PhoneIcon /> <strong>Phone (Tel)</strong>
              <br />
              (579) 85582439
              <br />
              (579) 85582440
              <br />
              (579) 85582441
            </p>
            <p>
              <MobileIcon /> <strong>Mobile</strong>
              <br /> +86-13857965630
            </p>
            <p>
              <FaxIcon /> <strong>Fax</strong>
              <br /> (579) 85582442
            </p>
            <p>
              <EmailIcon /> <strong>Email</strong>
              <br /> exports@newbell.net
            </p>
            <iframe
              title="China Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3478.6485246566954!2d120.09157700000002!3d29.321983999999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3449547513a8cc03%3A0xf07ae435192776d6!2sQuyuan%20Unit!5e0!3m2!1sen!2sin!4v1762550609214!5m2!1sen!2sin"
              width="100%"
              height="200"
              style={{ border: 0, marginTop: "15px" }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>

      <Footer />
      <ChatWithUs />
    </>
  );
};

export default Contact;